module.exports = "<svg viewBox=\"0 0 5 10\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 1.207v7.586a.5.5 0 0 0 .854.353l3.792-3.792a.5.5 0 0 0 0-.708L.854.854A.5.5 0 0 0 0 1.207z\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/svg/arrow-solid-right.svg
// module id = zbqJ
// module chunks = 89